module.exports = __webpack_public_path__ + "static/media/circle-download-pdf-grey-icon.fb0a0c8e.svg";